import { render } from "./AposFile.vue?vue&type=template&id=20524cda&scoped=true"
import script from "./AposFile.vue?vue&type=script&lang=js"
export * from "./AposFile.vue?vue&type=script&lang=js"

import "./AposFile.vue?vue&type=style&index=0&id=20524cda&scoped=true&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20524cda"],['__file',"ui/ui/apos/components/AposFile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20524cda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20524cda', __exports__)) {
    api.reload('20524cda', __exports__)
  }
  
  module.hot.accept("./AposFile.vue?vue&type=template&id=20524cda&scoped=true", () => {
    api.rerender('20524cda', render)
  })

}


export default __exports__